import React from 'react'

function HeartAce() {
    return (
    <>
        <g xmlns="http://www.w3.org/2000/svg" fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
            <g transform="translate(0 1)">
                <path fill="#DF3439" d="M6.992 17.488c-.503-.163-1.298.113-1.622 1.265-.422-1.168-1.104-1.411-1.623-1.265-.848.371-1.355 1.253-1.249 2.173 0 1.898 1.72 2.855 2.872 4.672 1.151-1.817 2.87-2.774 2.87-4.672.142-.927-.376-1.829-1.248-2.173z"/>
                <path fill="#DF3439" d="M5.37 24.35L5.37 24.333 5.353 24.35zM67.468 77.234c-1.152 1.817-2.871 2.774-2.871 4.688-.153.925.37 1.83 1.249 2.158.503.162 1.282-.114 1.622-1.266.406 1.168 1.103 1.428 1.622 1.266.846-.373 1.348-1.257 1.233-2.174-.016-1.898-1.72-2.855-2.855-4.672zM67.452 77.218L67.468 77.234 67.468 77.218zM40.442 42.259c-1.265-.39-3.244.308-3.958 3.163 0 .162-.114.162-.179 0-1.038-2.904-2.757-3.536-3.958-3.163-2.135.917-3.414 3.126-3.147 5.434 0 4.753 4.283 7.138 7.154 11.68 2.871-4.542 7.17-6.927 7.186-11.696.349-2.306-.934-4.549-3.098-5.418zM7.592 14.795L5.97 5.954H4.867l-1.623 8.84h-.746v.925h2.206v-.924h-.648l.26-1.363h2.173l.26 1.363h-.714v.924H8.24v-.924h-.649zm-3.066-2.369l.876-4.688.876 4.688H4.526zM65.23 86.789l1.622 8.825h1.103l1.622-8.825h.681v-.941h-2.125v.94h.633l-.243 1.347h-2.158l-.243-1.346h.665v-.941H64.58v.94h.649zm3.082 2.433l-.876 4.672-.925-4.672h1.8z"/>
            </g>
        </g>
    </g>
    </>
)
}

export default HeartAce
